import { CmpStyles } from '@packages/common/src/providers/style/types'

// todo: not working in stories; not working for @packages/common
export { identifier } from '@packages/common/src/providers/style/configure-renderer'

const cmpStyles = <T extends CmpStyles>(styles: T): T => styles

export default cmpStyles
